/**
 * Get all elements with the .gtm-event-class classname and add a listener on each
 * of them to send a GTM event automatically.
 *
 * The element must have necessarily a data-gtm-category attribute
 * and a .gtm-event-class classname to be tracked.
 *
 * You must add the data-gtm-label attribute to your element to use a
 * custom label otherwise the default label will be used.
 *
 * You don't need to call the react,vue,v1 sendGaEvent helper to send the event anymore
 * This script will do it for you.
*/

var targetElement = '[data-gtm-category]';

var dataAttributesHTML = {
  eventAction: 'gtmAction',
  eventCategory: 'gtmCategory',
  eventLabel: 'gtmLabel'
};

function handleGTMDefaultValues(element, eventAction) {
  return eventAction + ' no ' + element.tagName.toLowerCase() + ' ' + element.textContent + ' na pagina ' + document.title.split('|')[0];
}

function handleSendGTMEvent(event, element) {
  var elDataAttributes = element.dataset;

  var eventAction = event.type;
  var eventCategory = elDataAttributes[dataAttributesHTML.eventCategory];
  var eventLabel = elDataAttributes[dataAttributesHTML.eventLabel]
    || handleGTMDefaultValues(element, eventAction);

  sendGAEvent(eventCategory, eventAction, eventLabel);
}

function handleEventType(element) {
  var elementName = element.tagName.toLowerCase();

  return (elementName === 'input' && element.type.toLowerCase() !== 'radio')
  || elementName === 'select' ? 'blur' : 'click';
}

function addListenerOnElement(element) {
  var eventType = handleEventType(element);

  element.addEventListener(eventType, function (e) {
    handleSendGTMEvent(e, element);
  });
}

/**
 * Arrive is a lib that provides events to watch for DOM elements creation and removal.
 * It makes use of Mutation Observers internally.
 * @see https://github.com/uzairfarooq/arrive
*/
document.arrive(targetElement, function (element) {
  addListenerOnElement(element);
});
